import React, { useEffect, useState } from 'react';
import NotebookCnl from 'assets/images/new_plans_and_prices/notebook_cnl.png';
import Check from 'assets/images/new_plans_and_prices/check.svg';
import LegalSupport from 'assets/images/new_plans_and_prices/legal_support.png';
import OnlineCoursePlatform from 'assets/images/new_plans_and_prices/online-course-platform.png';
import { PackagesResponse } from 'store/modules/simulate_all_store/types';
import CardPlan from 'components/molecules/card_plan';
import { openSupportChat } from 'services/support_chat';
import { Container, ToggleButton, ToggleWrapper } from './styles';

interface SelectPlansProps {
  packages: PackagesResponse;
}

const SelectPlans: React.FC<SelectPlansProps> = ({ packages }) => {
  const [selectedPlan, setSelectedPlan] = useState<string>('');
  const [planos, setPlanos] = useState<string[]>([]);

  useEffect(() => {
    if (packages) {
      const planosTmp = Object.keys(packages);
      if (planosTmp.length > 0) {
        const annualPlan = planosTmp.find((plan) => plan.toLowerCase() === 'anual');
        setSelectedPlan(annualPlan ?? planosTmp[0]);
        setPlanos(planosTmp);
      }
    }
  }, [packages]);

  return (
    <Container>
      <div className="container">
        <div className="row">
          <div className="col-md-6 align-content-center mt-3">
            <h1 className="font-weight-bold">
              Venda mais e melhor
              <span className="d-md-block">para o governo com suporte</span>
              <span className="d-md-block">completo do ConLicitação</span>
            </h1>
            <ul className="mt-4">
              <li className="d-flex align-items-center pb-2">
                <img src={Check} alt="Check" />
                <p className="mb-0 ml-2">O maior banco de dados de licitações do país</p>
              </li>
              <li className="d-flex align-items-center pb-2">
                <img src={Check} alt="Check" />
                <p className="mb-0 ml-2">Mais de 6 mil fontes oficiais monitoradas diariamente</p>
              </li>
              <li className="d-flex align-items-center pb-2">
                <img src={Check} alt="Check" />
                <p className="mb-0 ml-2">Todas as licitações segmentadas para sua empresa</p>
              </li>
            </ul>
          </div>
          <div className="col-md-6">
            <img src={NotebookCnl} alt="Notebook Cnl" />
          </div>
        </div>
        <div className="full-width subscription-now">
          <div className="container text-center py-3">
            <h2 className="mb-0 font-weight-bold">Realizando sua assinatura hoje você terá</h2>
          </div>
        </div>
        <div className="full-access-platform mt-5">
          <h5 className="mb-4">Acesso completo à plataforma ConLicitação</h5>
          <div className="row">
            <div className="col-md-4">
              <ul>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Boletins de Licitações
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Encontrar Licitações
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Encontrar Acompanhamentos
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Encontrar Contratos
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Atas de Registro de Preços
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <ul>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Gerenciar Licitações
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Meu Histórico
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Análise de Mercado
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Licitações Estratégicas
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Concorrentes
                </li>
              </ul>
            </div>
            <div className="col-md-4">
              <ul>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Jurídico Fácil
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Gerenciar Documentos
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  Monitoramento de chat
                </li>
                <li className="d-flex align-items-center">
                  <i className="material-icons mr-2" style={{ verticalAlign: 'middle' }}>
                    check_circle
                  </i>
                  ConLicita GO
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row legal-support mt-5">
          <div className="col-md-3 mb-5 mb-md-0">
            <img src={LegalSupport} alt="Suporte jurídico especializado" />
          </div>
          <div className="col-md-9 align-content-center">
            <h5 className="font-weight-bold mb-3">Suporte jurídico especializado</h5>
            <p className="mb-0">
              Equipe de especialistas com mais de 25 anos de experiência no mercado de vendas para o
              governo, disponível para ajudar em todas as etapas do processo.
            </p>
          </div>
        </div>
        <div className="row online-course-platform">
          <div className="col-md-8 align-content-center mt-5 mt-md-0">
            <h5 className="font-weight-bold mb-3">Plataforma de cursos online</h5>
            <p className="mb-0">
              Aprenda tudo sobre vendas para o governo com mais de 100 cursos de especialização,
              aulas práticas e novos conteúdos atualizados mensalmente.
            </p>
          </div>
          <div className="col-md-4">
            <img src={OnlineCoursePlatform} alt="Plataforma de cursos online" />
          </div>
        </div>
        <div className="investment p-4 mb-5">
          <div className="text-center py-4">
            <h2 className="font-weight-bold">Investimento</h2>
            <p>
              Escolha um dos planos e tenha acesso a maior
              <span className="d-block">
                plataforma do mercado de licitações públicas do Brasil
              </span>
            </p>
          </div>
          <div className="d-flex justify-content-center mb-4">
            <ToggleWrapper>
              {planos &&
                planos.map((plano) => (
                  <ToggleButton
                    key={plano}
                    active={selectedPlan === plano}
                    onClick={() => setSelectedPlan(plano)}
                  >
                    {plano}
                  </ToggleButton>
                ))}
            </ToggleWrapper>
          </div>
          <div className="plans row px-3 justify-content-center">
            {packages[selectedPlan] &&
              Object.entries(packages[selectedPlan]).map(([pacote, formasPagamento]) => (
                <CardPlan
                  key={packages[selectedPlan] + pacote}
                  plano={selectedPlan}
                  pacote={pacote}
                  cartao={formasPagamento.card}
                  boleto={formasPagamento.invoice}
                />
              ))}
          </div>
        </div>
        <div className="talk-to-us full-width">
          <div className="container text-center py-3">
            <p className="mb-0 font-weight-light">
              Para mais informações e pacotes personalizados{' '}
              <button
                type="button"
                className="btn btn-link p-0 btn-talk-to-us"
                onClick={() => {
                  openSupportChat();
                }}
              >
                fale com um de nossos consultores
              </button>
            </p>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default SelectPlans;
